<template>
<div class="mHeader">
    <div class="m-header">
        <div class="logo img-title2"></div>
        <div class="search">
            <form action="/">
                <van-search v-model.trim="param.key" placeholder="输入关键字搜索" @search="onSearch"
                            @cancel="onCancel"></van-search>
            </form>
        </div>
        <div class="menu" @click="openMenu">
            <div class="icon" :class="[isShowMenu?'icon-close':'icon-menu']" ></div>
        </div>
    </div>
    <transition name="slide-sort">
        <MMenu v-if="isShowMenu" @openFollow="openFollow" @openTeamwork="openTeamwork"
               @openUpload="openUpload"></MMenu>
    </transition>
    <Popup :pop="follow" ref="follow"></Popup>
    <Popup :pop="upload" ref="upload"></Popup>
</div>
</template>

<script>
// import MMenu from 'views/reportMobile/components/mheader/mMenu'
import MMenu from 'views/mobile/components/mheader/my.vue'
import Popup from 'views/mobile/components/popup/popup'
import {mapActions} from 'vuex'
export default {
    name: 'mHeader',
    data() {
        return {
            follow: {
                url: require('@/common/images/mindex/img-follow-qrcode.png'),
                title: '',
                tip: ['关注公众号获取更多信息'],
                isSave: true,
                width: '4rem'
            },
            upload: {
                url: require('@/common/images/mindex/img-computer.png'),
                title: '',
                tip: ['请在pc端访问网址： ', 'http://czadmin.capwhale.com/login'],
                size: [1.1, 1],
                isSave: false,
                width: '5.4rem'
            },
            param: {
                key: ''
            },
            isShowMenu: false
        }
    },
    methods: {
        openFollow() {
            this.$refs.follow.open()
        },
        openTeamwork() {
            this.$refs.teamwork.open()
        },
        openUpload() {
            this.$refs.upload.open()
        },
        openMenu() {
            this.isShowMenu = !this.isShowMenu
            if (this.isShowMenu) {
                document.body.classList.add('overflow-hidden');
                // document.addEventListener('touchmove', this.touchStart,{passive:false});//一般第三个参数可直接填false,true -> 表示在捕获阶段调用事件处理程序, false -> 表示在冒泡阶段调用事件处理程序使用，但是touchmove会被浏览器忽略掉，并不会阻止默认行为，这里通过passive:false明确声明为不是被动的

            } else {
                document.body.classList.remove('overflow-hidden');
                // document.removeEventListener('touchmove',this.touchStart,{passive:false});
            }
        },
        touchStart(){
            event.preventDefault() //通知 Web 浏览器不要执行与事件关联的默认动作
        },
        onSearch() {
            this.setRefresh(true)
            this.$router.push({name: 'MReportSearch', query: {key: encodeURI(this.param.key)}})
        },
        onCancel() {

        },
        ...mapActions(['setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Popup, MMenu
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mHeader {
    .m-header{
        background: $c-white;
        position: fixed;
        z-index: 2;
        top:0;
        left:0;
        right:0;
        height: 0.88rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow:0 0.02rem 0.06rem 0 rgba(0,0,0,0.1);
        .logo{
            margin: 0.15rem 0.28rem 0.15rem 0.32rem;
            margin-left: 0.32rem;
            margin-right: 0.28rem;
            width: 2.35rem;
            height: 0.37rem;
        }
        .search{
            margin: 0.15rem 0;
            width: 3.6rem;
            height: 0.58rem;
            background: $c-lightGray;
            border-radius: 0.3rem;
            padding: 0 0.1rem 0 0.1rem;
            box-sizing: border-box;
            .van-search{
                padding: 0;
                background: transparent;
                .van-search__content{
                    background: transparent;
                }
                .van-field__body{
                    .van-icon-clear{
                        margin-right: 0.1rem;
                    }
                }
                .van-cell{
                    position: relative;
                    line-height: 1;
                    padding: 0 0.16rem 0 0;
                    .van-field__left-icon{
                        position: absolute;
                        top: 0.14rem;
                        right: 0;
                        margin-right: 0;
                    }
                    .van-field__body{
                        input{
                            padding: 0.1rem 0;
                            box-sizing: border-box;
                            height: 0.6rem;
                            line-height: 0.6rem;
                        }
                    }
                }
            }
        }
        .menu{
            padding: 0.15rem 0.32rem 0.15rem 0.28rem;
            .icon{
                width: 0.36rem;
                height: 0.36rem;
            }
        }

    }
    .slide-sort-enter-active, .slide-sort-leave-active{
        transition: all 0.5s
    }
    .slide-sort-enter, .slide-sort-leave-to{
        transform: translate3d(100%, 0, 0)
    }
}
</style>